import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Input,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import {
  setSelectedCollections,
  setSelectedAllCollections,
} from '../../actions/Collections';

const CollectionsSelectAll = ({
  collections,
  collectionsTotal,
  selectedCollections,
  selectedAllCollections,
  share,
  selectVisibleCollections,
  selectAllCollections,
  unselectAllCollections,
}) => {
  const intl = useIntl();

  const loadedCollections = collections.length;
  const isSelectAllChecked = loadedCollections > 0 &&
    collections.every(collection => selectedCollections.some(selectedCollection => (
      selectedCollection.uuid === collection.uuid
    )));
  const showSelectAll = collectionsTotal > loadedCollections;

  if (loadedCollections === 0) {
    return null;
  }

  return (
    <div className="list-select select-all-collections">
      {share ? (
        <>
          <label htmlFor="CollectionsSelectAll" id="CollectionsSelectAllLabel">
            {/* Select {loadedCollections} collection{loadedCollections === 1 ? '' : 's'} */}
            {intl.formatMessage({
              defaultMessage: 'Select {loadedCollections} {loadedCollections, plural, one {collection} other {collections}}',
            }, { loadedCollections })}
          </label>
          <div className="checkbox-wrapper">
            <Input
              type="checkbox"
              className="input-check check-l"
              id="CollectionsSelectAll"
              checked={isSelectAllChecked}
              onChange={() => {
                if (isSelectAllChecked) {
                  unselectAllCollections();
                } else {
                  selectAllCollections(collections);
                }
              }}
            />
          </div>
        </>
      ) : (
        <>
          <label htmlFor="CollectionsSelectAll">
            {intl.formatMessage({ defaultMessage: 'Select collections' })}
          </label>
          <UncontrolledButtonDropdown>
            <DropdownToggle id="CollectionsSelectAll" caret size="sm" color="secondary" className="select-all-button" />
            <DropdownMenu>
              <DropdownItem
                onClick={() => {
                  if (isSelectAllChecked && !selectedAllCollections) {
                    unselectAllCollections();
                  } else {
                    selectVisibleCollections(collections);
                    selectAllCollections(false);
                  }
                }}
              >
                {(isSelectAllChecked && !selectedAllCollections) && (
                  <i className="far fa-check" />
                )}
                {intl.formatMessage({ defaultMessage: 'Select visible ({loadedCollections})' }, { loadedCollections })}
              </DropdownItem>
              {showSelectAll && (
                <DropdownItem
                  onClick={() => {
                    if (selectedAllCollections) {
                      unselectAllCollections();
                    } else {
                      selectAllCollections(true);
                      selectVisibleCollections(collections);
                    }
                  }}
                >
                  {selectedAllCollections && (
                    <i className="far fa-check" />
                  )}
                  {intl.formatMessage({ defaultMessage: 'Select all ({collectionsTotal})' }, { collectionsTotal })}
                </DropdownItem>
              )}
              {(isSelectAllChecked || selectedAllCollections) && (
                <DropdownItem
                  onClick={() => {
                    unselectAllCollections();
                    selectAllCollections(false);
                  }}
                >
                  {intl.formatMessage({ defaultMessage: 'Unselect all' })}
                </DropdownItem>
              )}
            </DropdownMenu>
          </UncontrolledButtonDropdown>
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state, props) => ({
  collections: props.collections ?? state.Collections.collections,
  collectionsTotal: props.collectionsTotal ?? state.Collections.collectionsTotal,
  selectedCollections: state.Collections.selectedCollections,
  selectedAllCollections: state.Collections.selectedAllCollections,
  share: props.share !== undefined ? props.share : state.Shares.share,
});

const mapDispatchToProps = dispatch => ({
  selectVisibleCollections: (collections) => {
    dispatch(setSelectedCollections(collections));
  },
  selectAllCollections: (selectAllCollections) => {
    dispatch(setSelectedAllCollections(selectAllCollections));
  },
  unselectAllCollections: () => {
    dispatch(setSelectedCollections([]));
    dispatch(setSelectedAllCollections(false));
  },
});

CollectionsSelectAll.propTypes = {
  collections: PropTypes.array.isRequired,
  collectionsTotal: PropTypes.number.isRequired,
  selectedCollections: PropTypes.array.isRequired,
  selectedAllCollections: PropTypes.bool.isRequired,
  share: PropTypes.object,
  selectVisibleCollections: PropTypes.func.isRequired,
  selectAllCollections: PropTypes.func.isRequired,
  unselectAllCollections: PropTypes.func.isRequired,
};

CollectionsSelectAll.defaultProps = {
  share: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionsSelectAll);
